import React from 'react';
import {Modal} from "antd";
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import RentalCar from "./carinformation/RentalCar";

class CarInfoModal extends React.Component {

  render() {
    const {intl:{formatMessage}, visible, selectedCar} = this.props;

    return (
      <Modal title={formatMessage({id: 'section.car-information.modal.title'})}
             visible={visible} footer={null} onCancel={this.props.onModalClose}>
          <RentalCar vehicle={selectedCar}/>
      </Modal>
    )
  }
}

export default (withAuthorization(injectIntl(CarInfoModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/carpark/management/CarInfoModal.js